
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"version":"1.1","id":"Capa_1","xmlns":"http://www.w3.org/2000/svg","x":"0","y":"0","viewBox":"0 0 512 512","xml:space":"preserve"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{staticClass:"st0",attrs:{"d":"M446.6 124.4l-120-120C323.8 1.6 320 0 316 0H106C81.2 0 61 20.2 61 45v422c0 24.8 20.2 45 45 45h300c24.8 0 45-20.2 45-45V135c0-4.1-1.7-7.9-4.4-10.6zM331 51.2l68.8 68.8H346c-8.3 0-15-6.7-15-15V51.2zM406 482H106c-8.3 0-15-6.7-15-15V45c0-8.3 6.7-15 15-15h195v75c0 24.8 20.2 45 45 45h75v317c0 8.3-6.7 15-15 15z"}}),_c('path',{staticClass:"st0",attrs:{"d":"M346 212H166c-8.3 0-15 6.7-15 15s6.7 15 15 15h180c8.3 0 15-6.7 15-15s-6.7-15-15-15zM346 272H166c-8.3 0-15 6.7-15 15s6.7 15 15 15h180c8.3 0 15-6.7 15-15s-6.7-15-15-15zM346 332H166c-8.3 0-15 6.7-15 15s6.7 15 15 15h180c8.3 0 15-6.7 15-15s-6.7-15-15-15zM286 392H166c-8.3 0-15 6.7-15 15s6.7 15 15 15h120c8.3 0 15-6.7 15-15s-6.7-15-15-15z"}})])
          )
        }
      }
    